import { extendRequiredParameter } from "./apply.js";
import { bibliographyStyles } from "./data/bibliography-styles.js";
const values = Object.values(bibliographyStyles).flat();
export function buildBibliographyStyleCompletions(completions) {
    // TODO: find bibliography package from context and use only relevant styles
    for (const item of values) {
        completions.bibliographyStyles.push({
            type: "bib",
            label: item,
            extend: extendRequiredParameter,
        });
    }
}
